import api from "../Services/Api";
import {observable} from "mobx";

class EventTesterStore {
    @observable stockTransferEventId: string = "";
    @observable skladEntityChangedEventId: string = "";
    @observable visible: boolean = false;
    @observable forDebug: boolean = false;

    setStockTransferEventId(value: string) {
        this.stockTransferEventId = value;
    }
    
    setSkladEntityChangedEventId(value: string) {
        this.skladEntityChangedEventId = value;
    }

    async triggerStockTransferEventHandler() {
        const result = await api.post('admin/stockTransferEventHandler.trigger', {
            id: this.stockTransferEventId,
            forDebug: this.forDebug
        });
        if (result.success) {
            this.setStockTransferEventId('')
        }
    }

    async triggerSkladEntityChangedEventHandler() {
        const result = await api.post('admin/skladEntityChangedEventHandler.trigger', {
            id: this.skladEntityChangedEventId,
            forDebug: this.forDebug
        });
        if (result.success) {
            this.setSkladEntityChangedEventId('')
        }
    }

    show() {
        this.visible = true;
    }

    hide() {
        this.visible = false;
        this.stockTransferEventId = "";
        this.skladEntityChangedEventId = "";
        this.forDebug = false;
    }
    
    changeForDebug(value: boolean) {
        this.forDebug = value;
    }
}

export default new EventTesterStore();